const classes = {
  container:{
    display: 'flex',
    flexDirection: 'row',
    minHeight: "100vh",
    // alignItems: 'start',
    position: 'relative',
  },
  sidebar_container: {
    flex: 1,
    display: { xs: "none", md: "contents" },
  },
  sidebar_wrapper: {
    flexShrink: 0,
    display: { xs: "none", md: "block" },
    height: '100vh',
    position: 'sticky',
    top: 0,
  },
  navbar_container: {
    flex: 1,
    minWidth: 0,
    transition: 'margin-left 0.3s ease-in-out',
  },
  outlet_container: {
    marginRight: '48px',
    marginLeft: '48px',
    marginTop: '32px',
    marginBottom: '32px',
  },
  drawer: {
    display: { xs: "flex", md: "none" }
  },
  toggle_button: {
    position: 'fixed',
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 1300,
    backgroundColor: 'white',
    boxShadow: '2px 0 8px rgba(0,0,0,0.15)',
    borderRadius: '0 8px 8px 0',
    padding: '12px 8px',
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
    display: { xs: 'none', md: 'flex' },
  }

};

export default classes